/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';

import { StatsTableBody } from '../../../../common/stats-table/StatsTableBody';
import classNames from 'classnames';
import { careerAndSeasonStatsBenchmarkingSelector } from '../../../../../../../store/js/modules/statspro/career-and-season-stats/selectors';
import { SvgIcon } from '../../../../../../../../../common/react/components/SvgIcon';
import { TeamIcon } from '../../../../../../../../../common/react/components/TeamIcon';
import { useSelector } from 'react-redux';

/**
 * @param {object} props - Props.
 * @param {object[]} props.rows - Rows to render.
 * @param {Function} props.getTableBodyProps - Get table body props function.
 * @param {Function} props.prepareRow - Prepare row function.
 * @returns {JSX.Element} Component.
 */
export const TableBody = ({ rows, getTableBodyProps, prepareRow }) => {
    const benchmarking = useSelector(careerAndSeasonStatsBenchmarkingSelector);

    return (
        <StatsTableBody
            rows={rows}
            getTableBodyProps={getTableBodyProps}
            prepareRow={prepareRow}
            getBenchmark={(row, cell) => getBenchmark(cell, benchmarking)}
            customCells={
                (!rows[0].values.round && {
                    year: (row, cell, cellProps) => (
                        <th
                            {...cellProps}
                            className={classNames(
                                'stats-table__row-header-cell',
                                {
                                    'stats-table__cell--sorted':
                                        cell.column.isSorted
                                }
                            )}
                        >
                            {cell.value}
                        </th>
                    ),
                    club: (row, cell, cellProps) => (
                        <td {...cellProps} className="stats-table__cell">
                            <div className="career-and-season-stats__team">
                                <TeamIcon providerId={cell.value.teamId} />
                                <span className="u-hide-until-desktop">
                                    {cell.value.teamName}
                                </span>
                                <span className="u-hide-from-desktop">
                                    {cell.value.teamAbbr}
                                </span>
                            </div>
                        </td>
                    )
                }) || {
                    round: (row, cell, cellProps) => (
                        <th
                            {...cellProps}
                            className={classNames(
                                'stats-table__row-header-cell',
                                {
                                    'stats-table__cell--sorted':
                                        cell.column.isSorted
                                }
                            )}
                        >
                            {cell.value}
                        </th>
                    ),
                    opponent: (row, cell, cellProps) => (
                        <td {...cellProps} className="stats-table__cell">
                            <div className="career-and-season-stats__team">
                                <TeamIcon providerId={cell.value.teamId} />
                                <span className="u-hide-until-desktop">
                                    {cell.value.teamName}
                                </span>
                                <span className="u-hide-from-desktop">
                                    {cell.value.teamAbbr}
                                </span>
                            </div>
                        </td>
                    ),
                    result: (row, cell, cellProps) => (
                        <td {...cellProps} className="stats-table__cell">
                            {cell.value.score && (
                                <div className="career-and-season-stats__result">
                                    <span
                                        className={classNames(
                                            'career-and-season-stats__outcome',
                                            {
                                                'career-and-season-stats__outcome--win':
                                                    cell.value.outcome === 'W',
                                                'career-and-season-stats__outcome--loss':
                                                    cell.value.outcome === 'L',
                                                'career-and-season-stats__outcome--draw':
                                                    cell.value.outcome === 'D'
                                            }
                                        )}
                                    >
                                        {cell.value.outcome}
                                    </span>
                                    {cell.value.score}
                                </div>
                            )}
                        </td>
                    )
                }
            }
        />
    );
};

TableBody.propTypes = {
    rows: PropTypes.array.isRequired,
    getTableBodyProps: PropTypes.func.isRequired,
    prepareRow: PropTypes.func.isRequired
};

const getBenchmark = (cell, benchmarking) => {
    return (
        benchmarking.isActive && cell.row.original.benchmarks[cell.column.id]
    );
};
